export const ALL_DISCONNECTIONS = 'ALL_DISCONNECTIONS';
export const ONLY_ASSIGNED_DEVICES = 'ONLY_ASSIGNED_DEVICES';
